import { render, staticRenderFns } from "./ReductionOfInsurable.vue?vue&type=template&id=6f2ca97a&scoped=true&"
import script from "./ReductionOfInsurable.vue?vue&type=script&lang=js&"
export * from "./ReductionOfInsurable.vue?vue&type=script&lang=js&"
import style0 from "./ReductionOfInsurable.vue?vue&type=style&index=0&id=6f2ca97a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2ca97a",
  null
  
)

export default component.exports